
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("kZYBr", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $a3ee0fc92130ba0b$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Czech
var $a3ee0fc92130ba0b$export$2e2bcd8739ae039 = {
    'people.menu.renotify.flag.description': "V\u0161em zas\xedl\xe1me e-mail s\xa0p\u0159ipomenut\xedm. M\u016F\u017Ee to trvat a\u017E minutu.",
    'people.menu.renotify.flag.description.confluence': "Po\u0161lete koleg\u016Fm p\u0159ipomenut\xed",
    'people.menu.renotify.flag.title': "Odes\xedl\xe1n\xed p\u0159ipomenut\xed",
    'people.menu.renotify.flag.title.confluence': "Op\u011Btovn\xe9 odesl\xe1n\xed e-mailu s\xa0pozv\xe1nkou",
    'people.menu.renotify.menu.description': "{userCount, plural, one {{userCount,number}\xa0\u010Dlov\u011Bk nep\u0159ijal pozv\xe1nku do produktu {product}. Pod\xedvejte se, kdo chyb\xed, a\xa0po\u0161lete mu p\u0159ipomenut\xed.} few {{userCount,number}\xa0lid\xe9 nep\u0159ijali pozv\xe1nku do produktu {product}. Pod\xedvejte se, kdo chyb\xed, a\xa0po\u0161lete jim p\u0159ipomenut\xed.} many {{userCount,number}\xa0\u010Dlov\u011Bka nep\u0159ijalo pozv\xe1nku do produktu {product}. Pod\xedvejte se, kdo chyb\xed, a\xa0po\u0161lete jim p\u0159ipomenut\xed.} other {{userCount,number}\xa0lid\xed nep\u0159ijalo pozv\xe1nku do produktu {product}. Pod\xedvejte se, kdo chyb\xed, a\xa0po\u0161lete jim p\u0159ipomenut\xed.}}",
    'people.menu.renotify.menu.description.confluence': "N\u011Bkte\u0159\xed lid\xe9 nep\u0159ijal pozv\xe1nku do Confluence. Pod\xedvejte se, kdo chyb\xed, a\xa0po\u0161lete mu p\u0159ipomenut\xed.",
    'people.menu.renotify.menu.dismiss': "Zav\u0159\xedt",
    'people.menu.renotify.menu.dismiss.confluence': "Te\u010F ne",
    'people.menu.renotify.menu.remind': "Zaslat p\u0159ipomenut\xed \u010Dlen\u016Fm t\xfdmu",
    'people.menu.renotify.menu.remind.confluence': "Po\u0161lete koleg\u016Fm p\u0159ipomenut\xed",
    'people.menu.renotify.menu.title': "Jsou tu s\xa0n\xe1mi v\u0161ichni?",
    'people.menu.renotify.modal.copied': "Odkaz byl zkop\xedrov\xe1n",
    'people.menu.renotify.modal.copy': "Kop\xedrovat odkaz s\xa0pozv\xe1nkou",
    'people.menu.renotify.modal.description': "Chyb\u011Bj\xedc\xedm \u010Dlen\u016Fm m\u016F\u017Eeme poslat p\u0159ipomenut\xed e-mailem, nebo m\u016F\u017Eete odkaz s\xa0pozv\xe1nkou sd\xedlet sami.",
    'people.menu.renotify.modal.description.confluence': "Ode\u0161lete znovu e-mail s\xa0pozv\xe1nkou nebo zkop\xedrujte a\xa0sd\xedlejte zvac\xed odkaz.",
    'people.menu.renotify.modal.dismiss': "Zru\u0161it",
    'people.menu.renotify.modal.resend': "Odeslat p\u0159ipomenut\xed",
    'people.menu.renotify.modal.resend.confluence': "Znovu odeslat pozv\xe1nku",
    'people.menu.renotify.modal.title': "Zaslat p\u0159ipomenut\xed chyb\u011Bj\xedc\xedm \u010Dlen\u016Fm",
    'people.menu.renotify.modal.title.confluence': "Zaslat p\u0159ipomenut\xed chyb\u011Bj\xedc\xedm t\xfdmov\xfdm koleg\u016Fm",
    'ptc.pm.collaborators.title': "Va\u0161i spolupracovn\xedci",
    'ptc.pm.error-heading': "N\u011Bco se pokazilo",
    'ptc.pm.error-image-alt-text': "Rozbit\xfd robot a lid\xe9, kte\u0159\xed usilovn\u011B pracuj\xed na jeho oprav\u011B.",
    'ptc.pm.error-text': "Tyto chyby sledujeme, ale klidn\u011B se na n\xe1s obra\u0165te, pokud obnoven\xed str\xe1nky probl\xe9m nevy\u0159e\u0161\xed.",
    'ptc.pm.num-members': "{memberCount, plural, one {{memberCount,number} \u010Dlen} few {{memberCount,number} \u010Dlenov\xe9} many {{memberCount,number} \u010Dlena} other {{memberCount,number} \u010Dlen\u016F}}",
    'ptc.pm.people': "Lid\xe9",
    'ptc.pm.teams': "T\xfdmy",
    'ptc.pm.view-your-profile': "Zobrazit v\xe1\u0161 profil",
    'ptc.pm.your-teams.title': "Va\u0161e t\xfdmy"
};

});


//# sourceMappingURL=cs.0a7db9ec.js.map
